import * as React from "react"
import { connect } from "react-redux"

import bem from "../../../bem"
import { DispatchProps, mapDispatchToProps } from "../actions"
import { GlobalState } from "../../../store"
import OldUIContext from "../../../olduicontext"

import Greeting from "./Greeting"
import GridComponent from "../../common/grid/GridComponent"
import Search from "./Search"
import GridConfiguration from "../../common/grid/configuration/GridConfiguration"
import { Bookmark, IShortcut } from "../../../models"
import { IWelcomePage } from "../index"

const b = bem.with("NewUI__welcome")

interface OwnProps {
    isSmartSearch: boolean
}

interface StateProps extends IWelcomePage {
    bookmarks: Record<string, Bookmark>
    shortcuts: Record<string, IShortcut>
}

type Props = OwnProps & StateProps & DispatchProps

export class WelcomePage extends React.Component<Props> {
    static contextType = OldUIContext
    context!: React.ContextType<typeof OldUIContext>

    render(): JSX.Element {
        const { isSmartSearch, bookmarks, shortcuts, isLoading, grid } =
            this.props

        return (
            <main className={`${b()} tw-p-4 is-inverted`}>
                <section className="tw-relative tw-mx-1/5 tw-mt-20 tw-mb-20">
                    <div className="tw-relative">
                        <Greeting />
                        <Search isSmartSearch={isSmartSearch} />
                    </div>
                </section>

                <section className="tw-flex tw-justify-end">
                    <GridConfiguration
                        grid={grid}
                        isLoading={isLoading}
                        reorderTiles={this.onGridReorder}
                        removeTile={this.onGridTileRemove}
                    />
                </section>

                <GridComponent
                    tiles={grid.tiles}
                    isLoading={isLoading}
                    bookmarks={bookmarks}
                    shortcuts={shortcuts}
                />
            </main>
        )
    }

    onGridReorder = (
        targetIndex: number,
        oldIndex: number,
        reorderedTileId: number,
        targetTileId: number,
    ): void => {
        this.props.updateTilesOrder(
            targetIndex,
            oldIndex,
            reorderedTileId,
            targetTileId,
        )
    }

    onGridTileRemove = (tileId: number): void => {
        this.props.removeTile(tileId)
    }
}

const mapStateToProps = (state: GlobalState): StateProps => ({
    bookmarks: state.bookmarks.bookmarks,
    shortcuts: state.shortcuts.shortcuts,
    ...state.welcomePage,
})

export default connect(mapStateToProps, mapDispatchToProps)(WelcomePage)
